import React from 'react'
import queryString from 'query-string'
import I18n from '../../lib/i18n'
import FallbackImage from '../FallbackImage'

const HotItemsGrid = (props, context) => {
  const { mobile_medium_url, name, url } = props.item
  const query = url.indexOf('?') !== -1 ? url.split('?')[1] : ''
  const params = queryString.parse(query)
  const _onClick = () => {
    props.onClick({ params })
  }
  return <div className='hot-item-grid grid col-6' onClick={_onClick}>
    <FallbackImage
      className='hot-item-image image'
      fallback_className='image-default'
      src={mobile_medium_url}
      alt={`hot-item-${name}`}
    />
    {
      name.split('|').map((word, index) => <div key={word} className='product-item-name'>
        { word }
      </div>)
    }
    { params && params.label && <div className='product-group-label'>{I18n.t(`labels.${params.label}`)}</div> }
  </div>
}

export default HotItemsGrid



// WEBPACK FOOTER //
// ./src/components/Grid/HotItemsGrid.js